import React, { useRef } from "react";
import useClickOutside from "../hooks/useClickOutside";
import { useModal } from "../contexts/modal.context";
import { Loader2 } from "lucide-react";

const LoadingModal = () => {
  const { isOpen, message, closeModal } = useModal();
  const ref = useRef<HTMLDivElement | null>(null);
  useClickOutside(ref, () => {
    closeModal();
  });

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[5000] flex  gap-2 items-center justify-center backdrop-blur-sm bg-black/55 ">
      {typeof message === "string" ? (
        <div className="flex p-10 py-6  bg-white items-center border dark:bg-gray-800 border-accent-500 justify-center gap-4 text-accent-500 rounded-md ">
          <Loader2 className="w-6 h-6 animate-spin text-accent-500" />
          <span className="text-sm hidden xs:inline font-medium text-accent-500">{message}</span>
        </div>
      ) : (
        message
      )}
    </div>
  );
};

export default LoadingModal;
